/**
 * @file Automatically generated by barrelsby.
 */

export * from './forgot-password.component';
